import { useContext } from "react";
import { UpdateBannerContext } from "./UpdateBannerProvider";

export const usePromoBanner = () => useContext(UpdateBannerContext);
